import { useState, useEffect } from 'react';
import { Offcanvas, Card, Badge } from 'react-bootstrap';
import { statelessJSON } from 'Export/ExportJson';
import { setSettings } from 'Import/ImportJson';
import { v4 } from 'uuid';

import { useSettings } from 'Settings';

let history = [];
let loaded = false;
let current = 0;

const GenChangesText = (old, current) => {
	for (const key in old) {
		if (typeof old[key] !== 'object') {
			if (old[key] !== current[key]) {
				return { var : key, value : current[key]}
			}
		} else {
			const changes = GenChangesText(old[key], current[key]);
			if (changes) {
				changes.var = `${key}/${changes.var}`;
				return changes
			}
		}
	}

	return null
}

const pushToHistory = (settings) => {
	for (;current > 0; --current) {
		history.shift();
	}

	const json = statelessJSON(settings);
	const diff = history.length > 0 ? GenChangesText(history[0].data, json) : 'start session';

	if (!diff)
		return;

	history.unshift({
		timestamp: Date.now(),
		data: json,
		changes: diff
	});

	if (history.length > 10)
		history.pop();
}

const loadHistoryItem = (id, settings) => {
	setSettings(history[id].data, settings);
	current = id;
	loaded = true
}

const HistoryItem = ({ id }) => {
	const [settings] = useSettings();
	let d = Math.floor((Date.now() - history[id].timestamp) / 1000);
	let df = "";

	if (d > 60) {
		d = d / 60
		if (d > 60) {
			d = d / 60
			df = `${Math.floor(d)} hour(s) ago`
		} else {
			df = `${Math.floor(d)} minute(s) ago`
		}
	} else {
		df = `${d} second(s) ago`
	}

	let info = null;

	if (typeof history[id].changes === 'string') {
		info = history[id].changes;
	} 
	return (
		<Card className="mb-3">
			<Card.Header className="d-flex align-items-center justify-content-between">
				<Card.Title>{df}
				</Card.Title>
					{
					id === current ? 
					<Badge bg="secondary">Current</Badge>
						: 
					<button
						className="btn btn-primary"
						onClick={() => loadHistoryItem(id, settings)}>
						Jump To
					</button>
					}
			</Card.Header>
			<Card.Body>
				<p>
					{ info ? info : <><b>{history[id].changes.var}</b> changed to <b>{`${history[id].changes.value}`}</b></>}
				</p>
			</Card.Body>
		</Card>
	)
}

const History = () => {
	const [settings] = useSettings();

	const [show, setShow] = useState(false)

	const handleShow = () => setShow(true);
	const handleHide = () => setShow(false);

	useEffect(() => {
		if (!loaded) {
			pushToHistory(settings)
		}

		loaded = false;
		// eslint-disable-next-line
	}, [settings]);

	return (
		<>
			<button className="btn btn-outline-success" onClick={handleShow}>History</button>
			<Offcanvas show={show} onHide={handleHide} placement="end">
				<Offcanvas.Header>
					<Offcanvas.Title>History</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					{
					history.map((e, i) => <HistoryItem key={v4()} id={i}/>)
					}
				</Offcanvas.Body>
			</Offcanvas>
		</>
	)
}

export default History;
